import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const AdminContext = createContext();

export function AdminProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAdmin();
    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      checkAdmin();
    });
    return () => subscription.unsubscribe();
  }, []);

  const checkAdmin = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) { setAdmin(null); setLoading(false); return; }

    const { data } = await supabase
      .from('admins')
      .select('*')
      .eq('user_id', session.user.id)
      .single();

    setAdmin(data || null);
    setLoading(false);
  };

  const logout = async () => {
    await supabase.auth.signOut();
    setAdmin(null);
  };

  // Helper: cek apakah super admin
  const isSuperAdmin = admin?.role === 'super_admin';

  return (
    <AdminContext.Provider value={{ admin, loading, logout, isSuperAdmin }}>
      {!loading && children}
    </AdminContext.Provider>
  );
}

export function useAdmin() {
  return useContext(AdminContext);
}